/* Copyright (c) 2016-2023 Planticle Pty Ltd */
"use strict";

import * as ko from 'knockout';

export function observePromise(p, initialValue) {
	var o = ko.observable(initialValue);
	o.error = ko.observable(null);
	o.loading = ko.observable(true);
	p.then(o).catch(o.error).finally(() => { o.loading(false) });
	return o;
}

// Make a computed out of a computed that returns a computed :-D
export function flatMapComputed(fn) {
	var obs = ko.pureComputed(fn);
	return ko.pureComputed(function(){
		return obs()();
	});
}

// Creates a 'computed' observable from a function that returns a promise instead of an immediate result
// Includes 'loading' and 'error' properties on the observable, which are themselves observables
export function asyncComputed(promiseFn) {
	var obs = ko.observable();
	obs.loading = ko.observable();
	obs.error = ko.observable();

	var currentToken;
	ko.computed(function() {
		var token = {}
		currentToken = token;

		var p = promiseFn();

		obs(undefined);
		obs.error(undefined);

		if(p) {
			obs.loading(true);
			p.then(function(x) {
				if(token === currentToken) { obs(x); }
			}).catch(function(e) {
				if(token === currentToken) { obs.error(e); }
			}).finally(function(e) {
				if(token === currentToken) { obs.loading(false); }
			});
		} else {
			obs.loading(false);
		}
	});

	return obs;
}


export function loader(promiseFn) {
    var status = ko.observable();
    var error = ko.observable();
    var value = ko.observable();

    function load() {
        status('loading');
        error(null);
        value(null);
        promiseFn().then(v => {
            status('loaded');
            value(v);
        }).catch(e => {
            console.log(e);
            error('Loading failed')
        });
    }
    load();
    return {
        status, error, value, load
    }
}
